export enum RecipientType {
  NORMAL,
  CCO,
  CC
}

